<i18n>
  {
    "ja": {
      "contact-warehouse": {
        "longer" : "この倉庫にお問い合わせ",
        "shorter" : "問い合わせ"
      }
    }
  }
</i18n>
<template>
  <div class="contact-sticky sticky bottom-0 left-0 w-full flex-grow flex items-center justify-end md:justify-center p-4 md:p-5 lg:px-40">
    <p class="text-xs text-black font-semibold mr-6 ml-20 lg:ml-0 whitespace-no-wrap">
      この倉庫にご興味のある方は、<br class="xl:hidden" /><span class="md:inline">お気軽にご相談ください。</span></p>
    <button class="heap-contact-warehouse-list contact-warehouse-link ml-3 md:ml-6" @click="openInquiry(warehouse)">
      <span class="md:hidden">{{ $t('contact-warehouse.shorter')}}</span><span class="hidden md:inline">{{ $t('contact-warehouse.longer')}}</span>
    </button>
  </div>
</template>

<style lang="scss" scoped>
.contact-sticky {
  background-color: #F1F1F1;
  filter: drop-shadow(0px -2px 10px rgba(0, 0, 0, 0.2));
}
.contact-tel {
  min-width: 120px;
  min-height: 44px;
  @apply rounded-full bg-orange text-white flex items-center justify-center text-13p;
  @screen md {
    min-width: 140px;
    border-bottom: 5px solid;
    @apply bg-transparent rounded-none text-13p text-black font-medium items-center flex-wrap justify-start border-orange leading-tight min-w-0 min-h-0;
  }
}
.contact-warehouse-link {
  min-width: 125px;
  min-height: 44px;
  @apply rounded-full bg-white flex items-center justify-center text-13p;
  @screen md {
    min-width: 205px;
    @apply bg-orange text-white
  }
}
</style>


<script>
export default {
  props: {
    warehouse: {
      type: Object,
      default: null
    }
  },
  methods: {
    openInquiry(warehouse) {
      const query = !!warehouse ? { warehouse_code: warehouse.displayNumber } : {}
      this.$router.push({ path: this.localePath('/inquiry/'), query });
    },
    onShowModal() {
      this.$emit('show-modal')
    }
  },
}
</script>